import { useEffect, useState } from "react";

const GlobalInternetHandler = () => {
  const [status, setStatus] = useState(navigator.onLine ? "online" : "offline");
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setStatus("online");
      setShowBanner(true);

      setTimeout(() => {
        setShowBanner(false);
      }, 3000);
    };

    const handleOffline = () => {
      setStatus("offline");
      setShowBanner(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div
      className={`fixed top-0 left-0 w-full text-white text-center py-2 z-[99999] transition-all duration-500 ${
        status === "online" ? "bg-green-600" : "bg-red-600"
      }`}
    >
      {status === "online"
        ? "✔ Internet Connection Restored"
        : "⚠ No Internet Connection"}
    </div>
  );
};

export default GlobalInternetHandler;
